import { render, staticRenderFns } from "./videoManagement.vue?vue&type=template&id=33930a5e&scoped=true&"
import script from "./videoManagement.vue?vue&type=script&lang=js&"
export * from "./videoManagement.vue?vue&type=script&lang=js&"
import style0 from "./videoManagement.vue?vue&type=style&index=0&id=33930a5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33930a5e",
  null
  
)

export default component.exports